{
  "de": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Phase ändern",
        "reset_columns": "Spalten zurücksetzen"
      },
      "labels": {
        "columns": "Spalten",
        "milestone": "Bitte wählen Sie eine neue Phase aus",
        "no_results": "Keine Einheiten gefunden"
      }
    }
  }
}
